import type { SortDescriptor } from '@progress/kendo-data-query';

import type { TransformSort } from './_sort.type';

/**
 * /** Create SortParam.
 *
 * @param {SortDescriptor[]} sort SortDescriptor list.
 * @param {TransformSort} transform Transform.
 *
 * @returns {string[]} SortParam.
 */
export function createSortParam(sort: SortDescriptor[], transform?: TransformSort): string[] {
  return sort.map(({ field, dir }) => {
    const transformField = transform ? transform(field) : field;

    return dir === 'asc' ? transformField : `-${transformField}`;
  });
}
